export default "__VITE_ASSET__Dpmmqk6h__"